import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';

export type SearchRefinementModalTypes =
  | 'location'
  | 'propertyConfig'
  | 'budgetModal'
  | 'multiIntent'
  | 'commute';

export const trackSearchRefinementModalOpen = (userAction: SearchRefinementModalTypes): void => {
  const event: DataGetter = () => ({
    schema: 'iglu:au.com.property/pca_search_refinement_modal_open/jsonschema/1-0-2',
    data: {
      event_name: 'pca_search_refinement_modal_open',
      user_action: userAction,
    },
  });
  trackEvent(event);
};
